import {ItemInterface} from "react-sortablejs";

export enum UploadStatus {
    uploading = 'uploading',
    uploadSuccess = 'uploadSuccess',
    uploadError = 'uploadError',
    ready = 'ready'
}

export default interface SlideData extends ItemInterface{
    pid: string,
    previewId?: string,
    pathInfoFilename?: string,
    src?: string,
    medium_url?: string,
    thumbnail_url?: string,
    type?: string,
    text?: string,
    width?: number,
    height?: number,
    status: UploadStatus,
    uploadProgress?: number,
    localFileName?: string,
    uploadError?: string,
    createdAt?: number,
    createdByUser?: boolean
}